export const NUMBER_LENGTH = 10;

export const COUNTRY_CODE_LENGTH = 3;

export const POSTAL_CODE_LENGTH = 6;
